module.exports = __webpack_public_path__ + "img/CARD_LOGO.e0a604d7.png";